import { CommonModule, Location } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DateSelectorComponent } from '@ildes/basic/date-selector/date-selector.component';
import { ProjectSelectorComponent } from '@ildes/basic/project-selector/project-selector.component';
import { SimpleHeaderComponent } from '@ildes/basic/simple-header/simple-header.component';
import { AllowActionDirective } from '@ildes/directives/allow-action.directive';
import { ApiManagerService } from '@ildes/services/api-manager.service';

@Component({
  selector: 'app-create-manual-reports',
  standalone: true,
  imports: [
    CommonModule,
    SimpleHeaderComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    DateSelectorComponent,
    MatProgressBarModule,
    ProjectSelectorComponent,
    AllowActionDirective,
  ],
  template: `
<div class="container">
    <div class="scrollable-content">
        <simple-header title="Añadir reporte" [back]="true" icon="close"></simple-header>
        <div class="padding-top-8">
            <app-project-selector [mandatorySelection]="true" [formControl]="projectForm" label="Proyecto"></app-project-selector>
        </div>
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nombre del informe</mat-label>
            <input placeholder="P ej: Informe de actividades Febrero." matInput [formControl]="name">
        </mat-form-field>
        <div class="section margin-top-8">
            <h3>Fecha de Creación</h3>
            <div>
                <date-selector [date]="createdDate" minYear=2000 maxYear=2080 (onChangeDate)="setCreatedDate($event)" ></date-selector>
            </div>
        </div>
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Descripción</mat-label>
            <textarea required rows="2" matInput [formControl]="description"></textarea>
            <mat-error>
            Es obligatorio indicar una descripción
            </mat-error>
        </mat-form-field>
        <div *ngFor="let file of files">
            <div class="margin-8">
            <mat-icon class="margin-right-8" >picture_as_pdf</mat-icon>
            <span>{{file.name}}</span>
        </div>
        <mat-divider></mat-divider>
        </div>
        <button (click)="fileInput.click()" mat-flat-button>
            <mat-icon>attachment</mat-icon> Adjuntar archivos
        </button>
        <input hidden (change)="onFileSelected($event)" #fileInput type="file" id="file" multiple>
        <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
        <div [allowAction]="['manualReports.create']" class="align-center padding-top-8">
            <button [disabled]="loading || invalidForm" mat-raised-button color="primary" (click)="addReport()" class="button-size-200">Subir informe</button>
        </div>
    </div>
</div>  
  `,
  styleUrls: ['./create-manual-reports.component.css'],
})
export class CreateManualReportsComponent {

  files;
  report;
  name = new FormControl('', [Validators.required]);
  description = new FormControl('', [Validators.required]);
  projectForm = new FormControl({selected: null, typed: ''}, [Validators.required]);
  createdDate = new Date();
  loading;
  constructor(
    private apiManager: ApiManagerService,
    private location: Location,
  ) {

  }
  ngOnInit(): void {
    this.report = history.state.report;
  }

  onFileSelected(event) {
    const { files } = event.target;

    if (!files?.length) {
      return;
    }

    this.files = [...this.files || [], ...Object.values(files)];
    event.target.value = "";
  }

  setCreatedDate(createdDate) {
    this.createdDate = createdDate?.selectedDate;
  }

  addReport() {
    const formData = new FormData();

    formData.append('project', this.projectForm.value.selected?.id);
    formData.append('description', this.description.value);
    for (let i = 0; i < this.files?.length; i++) {
      formData.append(`files[${i}]`, this.files[i], this.files[i].name);
    }

    formData.append('name', this.name.value);
    formData.append('createdDate', this.createdDate.toISOString());

    this.loading = true;
    this.apiManager.addReport(formData).subscribe(()=> {
      this.loading = false;
      this.location.back();
    }, () => {
      this.loading = false;
    })
  }

  get fileList() {
    const filesIt = Object.values(this.files);

    return filesIt.map(({ name }: any) => name);
  }

  get invalidForm() {
    return !this.files?.length ||
        !this.projectForm?.value?.selected?.id ||
        !this.name?.value ||
        !this.description?.value;
  }
}
